module.exports = __webpack_public_path__ + "img/LogoWeConnect_Color.7de47ed0.png";